import React from 'react';
import styled from 'styled-components';

import theme, {bp, color} from 'settings/theme'

type Props = {
  size?: number
};

// Component
const Component: React.FC<Props> = (props) => {

	return(
    <StyledComponent className="loader">
      {/* <Pulse size={props.size} color={color.blue(30)} /> */}
      Loading...
    </StyledComponent>
	);

};


Component.defaultProps = {
  size: 40,
} as Partial<Props>;


export default Component;


// Styles
const StyledComponent = styled.div``;